import { Directive, inject, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractComponent } from '../abstract.component';
import { SolDialog } from '../../models/core/sol-dialog';
import { SolValidationMessage } from '../../models/core/sol-validation-message';

export interface SolDialogState {
  readonly dialog: SolDialog;
  withDialog(dialog: SolDialog): this;
}

export const DIALOG_CLOSE = new InjectionToken<() => void>('dialog-close');

@Directive()
export abstract class AbstractDialogComponent<S extends SolDialogState> extends AbstractComponent<S> {
  private readonly _close = inject(DIALOG_CLOSE);

  public onConfirm: () => void | Observable<void> = () => {
    console.warn(`${this.constructor.name}: onConfirm not assigned`);
  };

  public close(): void {
    this._close();
  }

  public abstract showErrors(messages: SolValidationMessage[]): void;

  protected onAction(actionId: string): void {
    if (actionId === 'cancel' || actionId === 'close') {
      this.close();
      return;
    }
    if (actionId === 'confirm') {
      this.handleConfirm();
    }
  }

  protected abstract handleConfirm(): void;
}
